import { render, staticRenderFns } from "./DataMaintenance.vue?vue&type=template&id=165ddb5d&scoped=true"
import script from "./DataMaintenance.vue?vue&type=script&lang=js"
export * from "./DataMaintenance.vue?vue&type=script&lang=js"
import style0 from "./DataMaintenance.vue?vue&type=style&index=0&id=165ddb5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ddb5d",
  null
  
)

export default component.exports